import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { vekaletAPI } from '../api/api';
import './Vekaletler.css';

const Vekaletler = () => {
  const navigate = useNavigate();
  const [vekaletler, setVekaletler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMuvekkil, setSelectedMuvekkil] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const data = await vekaletAPI.getAll();
      setVekaletler(data);
    } catch (error) {
      console.error('Vekaletler yüklenirken hata:', error);
      alert('Vekaletler yüklenirken hata oluştu: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  // Unique müvekkilleri çıkar
  const uniqueMuvekkiller = useMemo(() => {
    const muvekkiller = vekaletler
      .map(v => v.Muvekkil || v.muvekkil)
      .filter(m => m && m.trim() !== '');
    
    // Unique yap ve sırala
    return [...new Set(muvekkiller)].sort();
  }, [vekaletler]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('tr-TR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } catch {
      return dateString;
    }
  };

  const handleRowClick = (caseFileId) => {
    if (caseFileId) {
      navigate(`/case-files/${caseFileId}`);
    }
  };

  const filteredVekaletler = vekaletler.filter(vekalet => {
    const muvekkil = (vekalet.Muvekkil || vekalet.muvekkil || '').trim();
    const muvekkilLower = muvekkil.toLowerCase();
    const foyNo = (vekalet.FoyNo || vekalet.foyNo || '').toString();
    const search = searchTerm.toLowerCase();
    
    // Müvekkil filtresi (case-insensitive)
    const muvekkilMatch = !selectedMuvekkil || muvekkilLower === selectedMuvekkil.toLowerCase();
    
    // Arama filtresi
    const searchMatch = !searchTerm || muvekkilLower.includes(search) || foyNo.includes(search);
    
    return muvekkilMatch && searchMatch;
  });

  if (loading) {
    return <div className="vekaletler-page">Yükleniyor...</div>;
  }

  return (
    <div className="vekaletler-page">
      <div className="page-header">
        <h1>Vekaletler</h1>
      </div>

      <div className="filter-panel">
        <div className="filter-left">
          <select
            value={selectedMuvekkil}
            onChange={(e) => setSelectedMuvekkil(e.target.value)}
            className="muvekkil-select"
          >
            <option value="">Tüm Müvekkiller</option>
            {uniqueMuvekkiller.map((muvekkil, index) => (
              <option key={index} value={muvekkil}>
                {muvekkil}
              </option>
            ))}
          </select>
        </div>
        <div className="filter-right">
          <input
            type="text"
            placeholder="Ara (Müvekkil, Föy No)..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Föy No</th>
              <th>Müvekkil</th>
              <th>Vekalet Türü</th>
              <th>Vekalet Bitiş Tarihi</th>
              <th>Vekaletin Aslı Var</th>
            </tr>
          </thead>
          <tbody>
            {filteredVekaletler.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
                  Vekalet bulunamadı
                </td>
              </tr>
            ) : (
              filteredVekaletler.map((vekalet) => (
                <tr
                  key={vekalet.Id || vekalet.id}
                  onClick={() => handleRowClick(vekalet.CaseFileId || vekalet.caseFileId)}
                  style={{ cursor: 'pointer' }}
                >
                  <td>{vekalet.FoyNo || vekalet.foyNo || '-'}</td>
                  <td>{vekalet.Muvekkil || vekalet.muvekkil || '-'}</td>
                  <td>{vekalet.VekaletTuru || vekalet.vekaletTuru || '-'}</td>
                  <td>
                    {vekalet.VekaletTuru === 'Süreli' || vekalet.vekaletTuru === 'Süreli'
                      ? formatDate(vekalet.VekaletBitisTarihi || vekalet.vekaletBitisTarihi)
                      : '-'}
                  </td>
                  <td>{vekalet.VekaletinAsliVar || vekalet.vekaletinAsliVar ? 'Evet' : 'Hayır'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Vekaletler;

